import { useState } from 'react';
import './SummaryTable.css'
import '../AudioGeneration/DraftSummary.css'
import SpinnerLoading from '../../LoadingComponent/SpinnerLoading';
import { AiAnimation } from '../../LottieAnimationItems/LAnimations';
import { axiosInstance } from '../../../axios';

function SummaryTable({ detailTopicSocket, id, setDetailTopicSocket }) {
    // Data and state definitions
    const [data, setData] = useState(null);
    const [editableField, setEditableField] = useState({ id: null, field: null });
    const [tempData, setTempData] = useState(null);
    const [editableCellId, setEditableCellId] = useState(null);
    const [detailTopic, setDetailTopic] = useState(detailTopicSocket);
    const [isLoading, setIsLoading] = useState(detailTopicSocket.loading);



    const toggleEditMode = (itemId, field) => {
        if (editableField.id === itemId && editableField.field === field) {
            setEditableField({ id: null, field: null });
            setTempData(null);  // Clear temporary data when closing edit mode
        } else {
            setEditableField({ id: itemId, field: field });
            const currentItem = detailTopicSocket.items.find(item => item.id === itemId);
            if (currentItem) {
                setTempData({ ...currentItem });
            }
        }
    };



    const handleSave = async (itemId, field) => {
        if(field === 'title'){
            console.log("title")
            try {
                const formDataUpdate = new FormData();
                formDataUpdate.append('title', tempData.title);
                const response = await axiosInstance.patch(`summarize_detail_topic/${id}/${itemId}/`, formDataUpdate);
    
                // Update detailTopicSocket with new data
                const updatedItems = detailTopicSocket.items.map(item => {
                    if (item.id === itemId) {
                        return { ...item, title: tempData.title, text: "Loading", loading: true };
                    }
                    return item;
                });
                setDetailTopicSocket({ ...detailTopicSocket, items: updatedItems });
    
                setEditableField({ id: null, field: null });
                setTempData(null);
    
            } catch (error) {
                // TODO: handle errors
            }
        }else{
            console.log("text")
            try {
                const formDataUpdate = new FormData();
                formDataUpdate.append('text', tempData.text);
                const response = await axiosInstance.patch(`summarize_detail_topic/${id}/${itemId}/`, formDataUpdate);
    
                // Update detailTopicSocket with new data
                const updatedItems = detailTopicSocket.items.map(item => {
                    if (item.id === itemId) {
                        return { ...item, title: tempData.title, text: tempData.text, loading: false };
                    }
                    return item;
                });
                setDetailTopicSocket({ ...detailTopicSocket, items: updatedItems });
    
                setEditableField({ id: null, field: null });
                setTempData(null);
    
            } catch (error) {
                // TODO: handle errors
            }
        }
    };

    const handleCancel = (itemId) => {
        setEditableField({ id: null, field: null });
        setTempData(null);
    };

    const handleTextChange = (e, itemId) => {
        const updatedItems = detailTopic.items.map(item => {
            if (item.id === itemId) {
                return { ...item, text: e.target.value };
            }
            return item;
        });
        setDetailTopic({ ...detailTopic, items: updatedItems });
    };

    const handleFieldChange = (e, itemId, field) => {
        if (tempData && tempData.id === itemId) {
            setTempData({ ...tempData, [field]: e.target.value });
        }
    };


    const [editStates, setEditStates] = useState({});


    // Function to handle edit click
    const handleEditClick = (rowId, text) => {
        setEditStates({
            ...editStates,
            [rowId]: { isEditing: true, originalText: text, currentText: text },
        });
    };


    // Render edit buttons
    const renderEditButtons = (section, id) => {
        const isEditing = section.id == id;

        if (isEditing) {
            return (
                <>
                    {/* {isEditing == agendaEditing && <a onClick={() => addAgendaEntry()} className="text-warning text-decoration-none" style={{ marginRight: 15 }}>
                        <i className="fa fa-fw fa-plus"></i>
                    </a>} */}

                    <a onClick={() => handleSave(section)} className="text-success text-decoration-none" style={{ marginRight: 15 }}>
                        <i className="fa fa-fw fa-save"></i>
                    </a>
                    <a onClick={() => handleCancel(section)} className="text-danger text-decoration-none">
                        <i className="fa fa-fw fa-close"></i>
                    </a>
                </>
            );
        } else {
            return (
                <>
                    <a onClick={() => handleEditClick(section)} className="text-body text-opacity-50 text-decoration-none">
                        <i className="fa fa-fw fa-edit"></i>
                    </a>
                    <a onClick={() => handleEditClick(section)} className="text-body text-opacity-50 text-decoration-none">
                        <i className="fa fa-fw fa-delete"></i>
                    </a>
                </>
            );
        }
    };


    // handle remove
    const handleRemove = async (itemId) => {
        const isConfirmed = window.confirm("삭제하시겠습니까?");
        if (isConfirmed) {
            try {
                // Send DELETE request to the server
                const response = await axiosInstance.delete(`summarize_detail_topic/${id}/${itemId}/`);
            } catch (error) {
                console.error("Error removing data:", error);
                setIsLoading(false); // Reset loading in case of error
                // TODO: handle errors
            }
        } else {
            // User clicked 'Cancel', do not proceed with removal
            console.log("Removal cancelled");
        }
    };

    // Add new row
    const handlePost = async () => {
        try {
            setIsLoading(true); // Set loading to true before the request

            // Send POST request to the server with newItemData
            const response = await axiosInstance.post(`summarize_detail_topic/${id}/`);
        } catch (error) {
            console.error("Error posting data:", error);
            setIsLoading(false); // Reset loading in case of error
            // TODO: handle errors
        }
    };


    return (<>
        <div className='card-body'>
            <div class="table-responsive " >

                <div class="d-flex align-items-center">
                    <div class="dropdown ms-auto">
                        <a href="#" class="text-white" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-h"></i></a>
                        <div class="dropdown-menu dropdown-menu-end" data-bs-theme="light" >
                            <a href="//www.youtube.com/watch?v=_AS5nu4u1ss" class="dropdown-item">View</a>
                        </div>
                    </div>
                </div>
                <div class="text-muted small"><span class="text-danger">*</span>주제가 맘에 안드시면 칸별 상단 오른쪽 GPT 재호출 가능합니다. <br></br>
      내용 수정이 필요하다면 상단 오른쪽 글 수정을 통해 수정해보세요.</div>
                <table class="table table-bordered shadow-sm">
                    
                    <thead>
                    </thead>
                    <tr ><td className='bold border' style={{ paddingLeft: 20 }} colspan="2">{detailTopicSocket.title} </td></tr>
                    {detailTopicSocket.items.length == 0 ? (<>
                        <tr >
                            <td className='text-center border' style={{ width: '25%', paddingLeft: 20, paddingRight: 20, verticalAlign: 'middle', position: 'relative', height: '120px' }}>
                                <p className='skeleton-loading'>test</p>
                            </td>
                            <td className='text-center border' style={{ paddingLeft: 20, paddingRight: 20 }}>
                                <p className='skeleton-loading'>test</p>
                            </td>
                        </tr>
                    </>) : (<>
                        {detailTopicSocket.items && Array.isArray(detailTopicSocket.items) && (<>
                            {detailTopicSocket.items.map((item) => (
                                <tr key={item.id}>
                                    <td className='text-center' style={{ width: '25%', verticalAlign: 'middle', position: 'relative', height: '250px' }}>
                                        {editableField.id === item.id && editableField.field === 'title' ? (
                                            <>
                                                <textarea
                                                    type="text"
                                                    value={tempData && tempData.id === item.id ? tempData.title : item.title}
                                                    className="form-control border text-center  shadow"
                                                    style={{height:'150px'}}
                                                    onChange={(e) => handleFieldChange(e, item.id, 'title')}
                                                />
                                                <a onClick={() => handleSave(item.id, 'title')} className="text-success text-decoration-none edit-icon-save" style={{ padding: 0 }}>
                                                    <i className="fas fa-fw fa-rocket" style={{ fontSize: '1.2em' }}></i>
                                                </a>
                                                <a onClick={() => handleCancel(item.id)} className="text-danger text-decoration-none edit-icon-close" style={{ padding: 0 }}>
                                                    <i className="fas fa-fw fa-close" style={{ fontSize: '1.2em' }}></i>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                {/* <input
                                                type="text"
                                                className="form-control-plaintext readonly text-center"
                                                value={item.title}
                                                readOnly={true}
                                            /> */}

                                                <p >{item.title}</p>
                                                {
                                                    item.loading ? (<>

                                                    </>) : (<>
                                                        <button className="text-black edit-icon button-reset" style={{ padding: 0 }}>
                                                            <i className="fa fa-fw fa-retweet " onClick={() => toggleEditMode(item.id, 'title')} style={{ display: 'block', fontSize: '1.2em' }}></i>
                                                        </button>
                                                        <button style={{ padding: 0 }} onClick={() => handleRemove(item.id)} className="text-danger edit-icon-remove button-reset">
                                                            <i className="fa fa-fw fa-trash-alt" style={{ display: 'block', fontSize: '1.2em' }}></i>
                                                        </button>
                                                    </>)
                                                }
                                            </>
                                        )}

                                    </td>
                                    <td style={{ position: 'relative', padding: 25, height: '250px', }} className='border'>
                                        {editableField.id === item.id && editableField.field === 'text' ? (
                                            <>
                                                <textarea
                                                    class="form-control border shadow"
                                                    style={{ width: '100%', height: '90%' }}
                                                    value={tempData && tempData.id === item.id ? tempData.text : item.text}
                                                    onChange={(e) => handleFieldChange(e, item.id, 'text')}
                                                />
                                                <button onClick={() => handleSave(item.id, 'text')} className="text-success text-decoration-none edit-icon-save button-reset" style={{ padding: 0 }}>
                                                    <i className="fas fa-fw fa-save" style={{ fontSize: '1.2em' }}></i>
                                                </button>
                                                <button onClick={() => handleCancel(item.id)} className="text-danger text-decoration-none edit-icon-close button-reset" style={{ padding: 0 }}>
                                                    <i className="fas fa-fw fa-close" style={{ fontSize: '1.2em' }}></i>
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                {/* <textarea
                                                value={item.text}
                                                class="form-control-plaintext readonly bg-white"
                                                disabled={true}
                                                style={{ width: '100%', height: '90%' }}

                                            /> */}
                                                {
                                                    item.loading ? (<>
                                                        <p className='skeleton-loading'>test</p>
                                                    </>) : (<>
                                                        <p style={{ whiteSpace: 'pre-line' }}>{item.text}</p>
                                                        <button className="text-black edit-icon-text button-reset" style={{ padding: 0 }}>
                                                            <i className="fa fa-fw fa-edit" style={{ display: 'block', fontSize: '1.2em' }} onClick={() => toggleEditMode(item.id, 'text')}></i>
                                                        </button>
                                                    </>)
                                                }

                                                {/* <a className="text-black edit-icon" style={{ padding: 0 }}>
                                                <i className="fa fa-fw fa-edit " onClick={() => toggleEditMode(item.id, 'text')} style={{ display: 'block', fontSize: '1.2em' }}></i>
                                            </a> */}
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </>)}
                    </>)}

                </table>
                <div className='text-center'>
                    <button className='btn btn-primary' onClick={() => handlePost()} style={{ width: 250 }}><i className="fa fa-fw fa-plus"></i>행 추가하기</button>
                </div>
            </div>
        </div>
    </>);
}

export default SummaryTable